import * as React from "react"
import { SVGProps, memo } from "react"

const WindbackBig = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 48 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 12.084V.417L9.417 15 24 29.584V17.917c9.654 0 17.5 7.846 17.5 17.5s-7.846 17.5-17.5 17.5-17.5-7.846-17.5-17.5H.667C.667 48.309 11.109 58.75 24 58.75c12.892 0 23.334-10.441 23.334-23.333 0-12.892-10.442-23.333-23.334-23.333Z"
      fill="#000"
    />
  </svg>
)

const MemoWindbackBig = memo(WindbackBig)
export default MemoWindbackBig
